import { TypeData } from '../../../interfaces';

export type TreeItem = {
  id: string;
  label: string;
  children: TreeItem[];
  archived: boolean;
  disabled: boolean;
  paid: boolean;
  visible?: boolean;
};

export const getTreeData = (
  types: TypeData[],
  parent: string | number | null,
  activeIds?: string[]
): TreeItem[] =>
  types
    .filter(({ parent_id }) => parent_id === parent)
    .reduce((acc, { id, title, archived, paid }) => {
      const visibleByActiveData =
        !activeIds || activeIds.includes(String(id)) ? true : false;
      const childrenData = getTreeData(types, id, activeIds);
      const visibleByChildren = childrenData.length ? true : false;

      if (!visibleByActiveData && !visibleByChildren) return acc;

      acc.push({
        id: String(id),
        label: title,
        archived,
        paid: !!paid,
        disabled: !visibleByActiveData,
        children: childrenData,
      });

      return acc;
    }, [] as TreeItem[]);
